import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
const bonuses = [{
  title: 'Resets de Alivio Rápido™',
  value: 39000,
  description: 'Micro rutinas suaves para esos días donde tu cuerpo se siente rígido, pesado o agotado.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_10_55_50_a.m..png?v=1779199022'
}, {
  title: 'Sistema Mañanas Livianas™',
  value: 45000,
  description: 'Ritual suave para empezar el día con más movilidad, energía y calma.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_11_01_45_a.m..png?v=1779199325'
}, {
  title: 'Moverte Sin Miedo™',
  value: 49000,
  description: 'Guía emocional para recuperar confianza en tu cuerpo sin presión ni exigencia.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_11_05_31_a.m..png?v=1779199545'
}, {
  title: 'Movimiento Sin Culpa™',
  value: 35000,
  description: 'Mini sistema emocional para dejar atrás la culpa, la presión y el perfeccionismo físico.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_11_07_39_a.m..png?v=1779199683'
}, {
  title: 'Mi Progreso Suave™',
  value: 29000,
  description: 'Tracker visual premium para sentir pequeños avances reales.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_03_43_p.m..png?v=1779203033'
}, {
  title: 'Tarjetas Volvé a Sentirte Bien™',
  value: 39000,
  description: 'Cards visuales mobile-first para implementar movimiento suave incluso en días cansados.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_05_40_p.m..png?v=1779203149'
}, {
  title: 'Días Difíciles™',
  value: 55000,
  description: 'Sistema anti-abandono emocional para cuando no tenés ganas, energía o motivación.',
  image: 'https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_09_20_p.m..png?v=1779203380'
}];
export function BonusSection() {
  return <section className="w-full px-5 md:px-8 py-24 md:py-40 bg-secondary" data-id="element-16">
      <div className="max-w-4xl mx-auto" data-id="element-17">
        <div className="text-center mb-20" data-id="element-18">
          <div className="inline-flex items-center justify-center gap-2 text-gold mb-6" data-id="element-19">
            <Gift className="w-5 h-5 md:w-6 md:h-6" data-id="element-20" />
            <span className="font-semibold tracking-[0.2em] uppercase text-[11px] md:text-xs" data-id="element-21">
              Bonos Exclusivos
            </span>
          </div>
          <h2 className="font-serif text-3xl md:text-5xl text-ink mb-6 leading-[1.1] tracking-tight" data-id="element-22">
            Si entrás HOY, te incluyo estos 7 bonos premium
          </h2>
          <p className="text-[17px] md:text-xl text-ink/80 max-w-2xl mx-auto leading-[1.75]" data-id="element-23">
            Diseñados para que sostengas el sistema incluso cuando todo se ponga
            difícil.
          </p>
        </div>

        <div className="flex flex-col gap-8 mb-24" data-id="element-24">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-base border border-gold/20 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row gap-6 md:gap-8 items-center shadow-sm hover:shadow-md transition-shadow duration-300" data-id="element-25">
              <div className="w-full md:w-56 shrink-0 rounded-xl overflow-hidden bg-secondary/30" data-id="element-26">
                <img src={bonus.image} alt={bonus.title} className="w-full h-auto object-contain" data-id="element-27" />
              </div>
              <div className="flex-1 text-center md:text-left" data-id="element-28">
                <h3 className="font-serif text-2xl text-ink mb-3 leading-[1.1] tracking-tight" data-id="element-29">
                  {bonus.title}
                </h3>
                <p className="text-[17px] md:text-lg text-ink/70 mb-5 leading-[1.6]" data-id="element-30">
                  {bonus.description}
                </p>
                <p className="text-gold font-medium text-lg" data-id="element-31">
                  Valor: <PriceDisplay amountArs={bonus.value} data-id="element-32" /> — TUYO GRATIS
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border border-gold bg-gold/5 rounded-3xl p-8 md:p-14 text-center shadow-sm" data-id="element-33">
          <h3 className="font-serif text-2xl md:text-3xl text-ink mb-8 leading-[1.1] tracking-tight" data-id="element-34">
            Resumen de Valor
          </h3>
          <div className="flex flex-col gap-4 text-[17px] md:text-xl text-ink/80 mb-10 leading-[1.6]" data-id="element-35">
            <p data-id="element-36">
              Valor total de los bonos: <PriceDisplay amountArs={291000} data-id="element-37" />
            </p>
            <p data-id="element-38">
              Valor total del sistema completo:{' '}
              <PriceDisplay amountArs={74999} strikethrough className="text-ink/50 ml-2" data-id="element-39" />
            </p>
          </div>
          <p className="font-serif text-4xl md:text-5xl text-primary leading-[1.1] tracking-tight" data-id="element-40">
            HOY: <PriceDisplay amountArs={14999} data-id="element-41" />
          </p>
        </motion.div>
      </div>
    </section>;
}